import { render, staticRenderFns } from "./TsType.vue?vue&type=template&id=54e9d5a4&scoped=true&"
import script from "./TsType.vue?vue&type=script&lang=js&"
export * from "./TsType.vue?vue&type=script&lang=js&"
import style0 from "./TsType.vue?vue&type=style&index=0&id=54e9d5a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e9d5a4",
  null
  
)

export default component.exports